import { Button, Group, Modal, Text } from "@mantine/core";

interface ConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: string;
  loading?: boolean;
}

/**
 * Reusable confirmation modal with two buttons (cancel and confirm).
 */
const ConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Potvrdi",
  cancelLabel = "Otkaži",
  confirmColor = "red",
  loading = false,
}: ConfirmationModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      size="sm"
      styles={{ title: { fontSize: 18, fontWeight: 600 } }}
    >
      <Text size="sm" mb="xl">
        {message}
      </Text>
      <Group justify="center" gap="md">
        <Button variant="outline" color="gray" radius="md" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button color={confirmColor} radius="md" onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmationModal;
